import type { JSX } from '@familyjs/core/components';
import { defineCustomElement } from '@familyjs/core/components/fml-alert.js';

import { createInlineOverlayComponent } from './createInlineOverlayComponent';

export const FmlAlert = /*@__PURE__*/ createInlineOverlayComponent<JSX.FmlAlert, HTMLFmlAlertElement>(
  'fml-alert',
  defineCustomElement
);
